const _3 = require('lodash');

_3.templateSettings = {
  interpolate: /{{([\s\S]+?)}}/g
};

const __3 = Object.freeze(_3);

// protect lodash 3 from being hacked
//
//
Object.defineProperty(window, '_', {
  configurable: false,
  get() {
    return __3;
  },
  set() {
    // never allow set
  }
});



// WEBPACK FOOTER //
// ./app/vendor/core-js-lib/src/main.ts